import React, { useEffect, useState } from 'react'
import { Field, change } from 'redux-form'
import { useDispatch } from 'react-redux'
import { AutoCompleteSelect } from '../../../../../../../../../../itrust_common/components/form'
import { required as requiredValidator } from '../../../../../../../../../../itrust_common/components/form/FormValidations'
import SpecteraBillAmountField from './SpecteraBillAmountField'
import { SPECTERA_CLAIM_FORM } from './constants'

const isCR39 = (val) => {
  const desc = val?.LENS_MATERIAL_DESCRIPTION || (typeof val === 'string' ? val : '')
  return (
    desc.includes('CR-39') ||
    val?.LENS_MATERIAL_ID === 4 ||
    val?.IS_BUNDLED === true
  )
}

const isNoTreatment = (val) => {
  const desc = val?.LENS_TREATMENT_DESCRIPTION || (typeof val === 'string' ? val : '')
  return (
    desc.toLowerCase().includes('no treatment') ||
    val?.LENS_TREATMENT_ID === null ||
    (val && typeof val === 'object' && 'LENS_TREATMENT_ID' in val && !val.LENS_TREATMENT_ID)
  )
}

const checkShouldDisable = (val) => Boolean(isCR39(val) || isNoTreatment(val))

export default function SpecteraLensDropdownRow({
  name,
  label,
  billAmountName,
  data = [],
  showBillAmount = true,
  valueField,
  textField,
  fieldKey,
  onChangeHook,
  disabled = false,
  formSection,
  required = false,
  validate,
}) {
  const dispatch = useDispatch()
  const [internalDisabled, setInternalDisabled] = useState(false)

  useEffect(() => {
    setInternalDisabled(false)
  }, [fieldKey])

  const handleChange = (selected) => {
    const shouldDisable = checkShouldDisable(selected)
    setInternalDisabled(shouldDisable)

    if (shouldDisable && billAmountName) {
      const fullPath = formSection ? `${formSection}.${billAmountName}` : billAmountName
      dispatch(change(SPECTERA_CLAIM_FORM, fullPath, null))
    }

    if (onChangeHook) {
      onChangeHook(selected)
    }
  }

  const handleReset = () => {
    setInternalDisabled(false)
    return true
  }

  const isBillDisabled = disabled || internalDisabled
  const fieldValidations = validate || (required ? [requiredValidator] : undefined)
  const displayLabel = required && typeof label === 'string' && !label.endsWith('*') ? `${label} *` : label

  return (
    <div className='row'>
      <Field
        name={name}
        valueField={valueField}
        textField={textField}
        label={displayLabel}
        data={data}
        key={`${name}-${fieldKey || ''}-${data?.length || 0}`}
        component={AutoCompleteSelect}
        onChangeHook={handleChange}
        onResetVal={handleReset}
        validate={fieldValidations}
        wrapperClasses="form-group col-6"
        isNilInputValue={true}
      />
      <span className='col-3' />
      {showBillAmount && (
        <SpecteraBillAmountField
          name={billAmountName}
          disabled={isBillDisabled}
        />
      )}
    </div>
  )
}
